(function () {
  function initDots(sliderComponent) {
    var dotsWrap = sliderComponent.querySelector('[data-slider-dots]');
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    if (!dotsWrap || !slider) return;

    function metrics() {
      var items = Array.prototype.filter.call(slider.children, function (el) {
        return el.clientWidth > 0;
      });
      if (items.length < 2) return null;

      var offset = items[1].offsetLeft - items[0].offsetLeft;
      if (offset <= 0) return null;

      var pages = Math.max(1, Math.round((slider.scrollWidth - slider.clientWidth) / offset) + 1);
      var current = Math.min(pages - 1, Math.max(0, Math.round(slider.scrollLeft / offset)));
      return { offset: offset, pages: pages, current: current };
    }

    function updateStaticState() {
      var isStatic = slider.scrollWidth <= slider.clientWidth + 1;
      slider.classList.toggle('is-static', isStatic);
      sliderComponent.classList.toggle('is-static', isStatic);
      return isStatic;
    }

    function render() {
      if (updateStaticState()) {
        dotsWrap.hidden = true;
        return;
      }

      var m = metrics();
      if (!m) {
        dotsWrap.hidden = true;
        return;
      }

      if (dotsWrap.childElementCount !== m.pages) {
        dotsWrap.textContent = '';
        for (var i = 0; i < m.pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'multicolumn-slider__dot';
          dot.setAttribute('aria-label', String(i + 1));
          dot.addEventListener(
            'click',
            (function (index) {
              return function () {
                var current = metrics();
                if (!current) return;
                slider.scrollTo({ left: index * current.offset, behavior: 'smooth' });
              };
            })(i)
          );
          dotsWrap.appendChild(dot);
        }
      }

      dotsWrap.hidden = m.pages < 2;

      Array.prototype.forEach.call(dotsWrap.children, function (dot, index) {
        dot.classList.toggle('is-active', index === m.current);
        if (index === m.current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    var frame = null;
    function scheduleRender() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = null;
        render();
      });
    }

    sliderComponent.addEventListener('slideChanged', scheduleRender);
    slider.addEventListener('scroll', scheduleRender);
    window.addEventListener('resize', scheduleRender);
    window.addEventListener('load', scheduleRender);
    if (window.ResizeObserver) new ResizeObserver(scheduleRender).observe(slider);

    render();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.multicolumn-slider').forEach(initDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
